import { gql } from "@apollo/client";

export const AUDIT_ZIPCODE_GEOFENCE = gql`
    mutation AuditZipcodeGeofence($id: Long!, $result: Boolean!,$level: Int!) {
        auditZipcodeGeofence(id: $id, result: $result,level: $level)
    }
`;

export interface AuditZipcodeGeofenceInput {
    id: number;
    result: boolean;
    // 审核级别：1=WMS(hub 审核)，2=围栏黑名单终审
    level: number;
}

export interface AuditZipcodeGeofenceResponse {
    auditZipcodeGeofence: boolean;
}
